<template>
    <div>
        <div id="video-slider-section">
            <carousel-3d :width="528" :height="296" :controls-visible="true">
                <slide v-for="(slide, i) in slides" :index="i" :key="i">
                    <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                        <div class="thumbnail-image">
                            <img class="yt-img-placeholder" :data-index="index"
                                :class="{ current: isCurrent, onLeft: leftIndex >= 0, onRight: rightIndex >= 0 }"
                                :src="'https://img.youtube.com/vi/' + slide.name + '/maxresdefault.jpg'" />
                            <div class="play-button">
                                <img v-if="isCurrent" src="https://assets.rhinorack.com/StowIt/big-play-icon.png" alt="Play"
                                    @click="playVideo(slide)" />
                            </div>
                            <div v-if="isCurrent && slide.isPlaying" class="video-container">
                                <iframe
                                    :src="'https://www.youtube.com/embed/' + slide.name + '?autoplay=1&rel=0&showinfo=0'"
                                    frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                            </div>
                        </div>
                    </template>
                </slide>
            </carousel-3d>
        </div>
    </div>
</template>
  
<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
    name: "video-3d-slider",
    components: {
        Carousel3d,
        Slide
    },
    props: {
        section: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            slides: [],
        };
    },
    created() {
        var videoArray = JSON.parse(this.section).items;
        videoArray.forEach((element) => {
            this.slides.push({
                name: element.field_4,
                isPlaying: false,
            });
        });
    },
    methods: {
        playVideo(slide) {
            slide.isPlaying = true;
        }
    }
};
</script>
  
<style lang="scss" scoped>
#video-slider-section {
    .carousel-3d-container {
        .carousel-3d-slider {
            .carousel-3d-slide {
                border: none;

                .thumbnail-image {
                    height: 100%;

                    .yt-img-placeholder {
                        height: 100%;
                        object-fit: contain;
                    }

                    .play-button {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        cursor: pointer;

                        img {
                            max-width: 40px;
                            max-height: 40px;
                        }
                    }

                    .video-container {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: rgba(0, 0, 0, 0.8);
                    }

                    iframe {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
            }
        }
    }
}</style>
  